import { useContext, useEffect, useState } from 'react';

import { AppContext } from '../../capabilities/contextStore/AppContext';

export default function usePollingIntervalController({
  customerId,
}: {
  customerId: string;
}) {
  const [isSubmitDone, setIsSubmitDone] =
    useState<boolean>(false);
  const [isComponentUnmounting, setIsComponentUnmounting] =
    useState<boolean>(false);
  const { setSessionOutcomePollingInterval } =
    useContext(AppContext);

  useEffect(() => {
    if (isSubmitDone && !isComponentUnmounting) {
      setSessionOutcomePollingInterval(10000);
      setIsComponentUnmounting(false);
      setIsSubmitDone(false);
    }
  }, [isSubmitDone, isComponentUnmounting]);

  useEffect(() => {
    if (!customerId) {
      return;
    }

    setSessionOutcomePollingInterval(10000);

    // eslint-disable-next-line consistent-return
    return () => {
      setIsComponentUnmounting(true);
      setSessionOutcomePollingInterval(undefined);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    setIsComponentUnmounting,
    setIsSubmitDone,
  };
}
